import { useCallback, useRef, useState } from "react";
import { Button, cn, Flex, Typography } from "djuno-design";
import ArrowsPointingOutIcon from "./../../assets/icons/arrows-pointing-out.svg?react";
import ArrowsPointingInIcon from "./../../assets/icons/arrows-pointing-in.svg?react";

const Iframe: React.FC<{
  children?: React.ReactNode;
  url: string;
  serviceName?: string;
}> = ({ children, url, serviceName }) => {
  const monitorRef = useRef<HTMLDivElement | null>(null);
  const [fullScreen, setFullScreen] = useState<boolean>(false);

  const maximize = useCallback(() => {
    setFullScreen(true);
  }, []);

  const minimize = useCallback(() => {
    setFullScreen(false);
  }, []);

  return (
    <div
      className={cn("flex flex-col w-full bg-gray-100 dark:bg-dark-3", {
        "relative rounded-tl-xl rounded-tr-xl rounded-xl pb-1 h-[460px]":
          !fullScreen,
        "z-[2147483004] fixed top-0 left-0 h-screen overflow-y-auto":
          fullScreen,
      })}
    >
      {fullScreen && (
        <header className="py-6 px-10">
          <Flex items="center" justify="between">
            <ol className="antialiased font-sans font-normal text-sm text-gray-900 leading-6 list-none flex space-x-4 m-0 p-0">
              <li className="text-gray-400 after:content-['/'] after:ml-4">
                {serviceName}
              </li>
              <li>
                <Typography.Text size="sm">Code editor</Typography.Text>
              </li>
            </ol>
            <Button
              tooltip={{ content: "Minimize", place: "bottom-end" }}
              onClick={minimize}
            >
              <ArrowsPointingInIcon className="w-4 aspect-square" />
            </Button>
          </Flex>
        </header>
      )}
      <div className="border-b border-solid border-gray-300 dark:border-gray-800">
        {/* filters */}
        <div
          className={cn(
            "flex lg:space-x-4 justify-stretch max-lg:flex-wrap items-center",
            {
              "px-10 mb-0": fullScreen,
              "px-3 py-3": !fullScreen,
            }
          )}
        >
          <Flex className="!flex-1 !w-full">{children}</Flex>
          {!fullScreen && (
            <div className="max-lg:order-4 ml-2">
              <Button
                tooltip={{ content: "Maximize", place: "bottom-end" }}
                onClick={maximize}
              >
                <ArrowsPointingOutIcon className="w-4 aspect-square" />
              </Button>
            </div>
          )}
        </div>
      </div>
      <div
        className="flex flex-col flex-1 overflow-y-scroll w-full p-0"
        ref={monitorRef}
      >
        <iframe
          src={url}
          className="w-full h-[calc(100vh-200px)]"
          // title="AI Notebook"
        ></iframe>

        {/* empty log */}
        {/* {logs.length === 0 && !loading && (
          <Flex items="center" justify="center" className="h-full px-4 w-full">
            <Flex
              direction="col"
              items="center"
              justify="center"
              className="gap-3 w-full"
            >
              <Typography.Text
                size="base"
                className="antialiased font-sans font-medium text-base leading-6"
              >
                No logs to show
              </Typography.Text>
              <Typography.Text
                size="sm"
                className="antialiased font-sans font-normal text-sm leading-6 max-w-md"
              >
                New log entries that match your search parameters will appear
                here.{" "}
              </Typography.Text>
            </Flex>
          </Flex>
        )} */}

        {/* loading */}
        {/* {loading && (
          <div className="h-full flex items-center justify-center px-4">
            <Loading borderSize={2} />
          </div>
        )} */}

        {/* results count */}
        {/* <div className="antialiased font-mono font-normal text-xs leading-6 tracking-tight w-full border-dashed border-t border-gray-300 dark:border-gray-800 px-4 pt-4 mt-auto text-center">
            <Text>All 7 matching logs loaded</Text>
        </div> */}
      </div>
    </div>
  );
};

export default Iframe;
